export default __webpack_public_path__ + "static/media/Thug's Leggings of the Firebringer.0cdf4db0.jpg";